<script lang="ts">
  import { DateTime } from "luxon";
  import { locale, t } from "svelte-i18n";

  export let dateString: string | null | undefined;

  $: currentLocale = $locale ?? "en";

  function dateView(
    dateString: string | null | undefined,
    currentLocale: string
  ): string {
    if (dateString) {
      let currentLocale = $locale ?? "en";
      const date = DateTime.fromISO(dateString, {
        locale: currentLocale,
        zone: "utc",
      });

      return date.toFormat("d MMMM yyyy");
    }
    return "";
  }
</script>

{dateView(dateString, currentLocale)}
